import React from 'react'
import { useStyles } from './styles.js'

const DownArrow = (props) => {
  const classes = useStyles()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.171"
      height="7.233"
      viewBox="0 0 13.171 7.233"
      id="downarrow"
      {...props}
    >
      <defs>
        {/* <style>.a{fill:none;}.b{clip-path:url(#a);}.c{clip-path:url(#b);}.d{fill:#545455;}</style> */}
        <clipPath id="a">
          <path
            class="a"
            fill="none"
            d="M334.3-22.333a.921.921,0,0,1,.032,1.3L334.3-21l-5.61,5.343a1,1,0,0,1-1.379,0L321.7-21a.921.921,0,0,1-.032-1.3l.032-.032a1.019,1.019,0,0,1,1.4,0l4.9,4.628h0l4.9-4.628A1.019,1.019,0,0,1,334.3-22.333Z"
            transform="translate(-321.414 22.614)"
          />
        </clipPath>
        <clipPath id="b">
          <path
            class="a"
            fill="none"
            d="M-19,330H356V-337H-19Z"
            transform="translate(19 337)"
          />
        </clipPath>
      </defs>
      <g transform="translate(0 0)">
        <g class="b" clipPath={`url('#a')`}>
          <g
            class="c"
            clipPath={`url('#b')`}
            transform="translate(-340.414 -314.386)"
          >
            <path
              class="d"
              fill="#FFF"
              d="M339.586-27.614v17.233H316.414V-27.614Z"
              transform="translate(19 337)"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
export default DownArrow
